document.addEventListener("DOMContentLoaded", function () {
  initModoSwipePages(document);
});

document.addEventListener("shopify:section:load", function (event) {
  initModoSwipePages(event.target);
});

function initModoSwipePages(scope) {
  const pages = scope.querySelectorAll("[data-modo-swipe-page]");

  pages.forEach(function (page) {
    if (page.dataset.modoSwipeReady === "true") {
      return;
    }

    page.dataset.modoSwipeReady = "true";

    const deck = page.querySelector("[data-modo-deck]");
    const loadingMessage = page.querySelector("[data-modo-loading]");
    const categoryScroll = page.querySelector(".modo-category-scroll");
    const categoryButtons = Array.from(page.querySelectorAll(".modo-category-chip"));
    const emptyMessage = page.querySelector("[data-modo-empty]");
    const actionButtons = Array.from(page.querySelectorAll("[data-modo-action]"));
    const toast = page.querySelector("[data-modo-toast]");

    const productLimit = Number(page.getAttribute("data-product-limit")) || 20;
    const currency = page.getAttribute("data-currency") || "USD";

    let rootUrl = page.getAttribute("data-root-url") || "/";
    if (!rootUrl.endsWith("/")) {
      rootUrl += "/";
    }

    let activeIndex = 0;
    let activeCards = [];
    let productsCache = {};

    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let isDraggingCard = false;

    const wishlistStorageKey = "modoSwipeWishlist";

    function showToast(message) {
      if (!toast) return;

      toast.textContent = message;
      toast.classList.add("active");

      setTimeout(function () {
        toast.classList.remove("active");
      }, 1800);
    }

    function showLoading() {
      if (loadingMessage) {
        loadingMessage.classList.add("active");
      }

      if (emptyMessage) {
        emptyMessage.classList.remove("active");
      }

      if (deck) {
        deck.innerHTML = "";
      }
    }

    function hideLoading() {
      if (loadingMessage) {
        loadingMessage.classList.remove("active");
      }
    }

    function showEmpty() {
      if (emptyMessage) {
        emptyMessage.classList.add("active");
      }
    }

    function hideEmpty() {
      if (emptyMessage) {
        emptyMessage.classList.remove("active");
      }
    }

    function escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function escapeAttribute(value) {
      return escapeHtml(value);
    }

    function parsePrice(value) {
      const number = Number(String(value || "0").replace(/[^0-9.]/g, ""));
      return Number.isNaN(number) ? 0 : number;
    }

    function formatMoney(priceNumber) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: currency
        }).format(priceNumber);
      } catch (error) {
        return "$" + priceNumber.toFixed(2);
      }
    }

    function getWishlist() {
      try {
        const savedWishlist = localStorage.getItem(wishlistStorageKey);

        if (!savedWishlist) {
          return [];
        }

        const parsedWishlist = JSON.parse(savedWishlist);

        if (Array.isArray(parsedWishlist)) {
          return parsedWishlist;
        }

        return [];
      } catch (error) {
        return [];
      }
    }

    function saveWishlist(items) {
      try {
        localStorage.setItem(wishlistStorageKey, JSON.stringify(items));

        window.dispatchEvent(
          new CustomEvent("modo:wishlist-updated", {
            detail: {
              items: items,
              count: items.length
            }
          })
        );

        return true;
      } catch (error) {
        return false;
      }
    }

    function getCollectionEndpoint(handle) {
      if (handle === "all") {
        return rootUrl + "collections/all/products.json?limit=" + productLimit;
      }

      return (
        rootUrl +
        "collections/" +
        encodeURIComponent(handle) +
        "/products.json?limit=" +
        productLimit
      );
    }

    function normalizeProduct(product) {
      const variants = Array.isArray(product.variants) ? product.variants : [];

      const firstAvailableVariant =
        variants.find(function (variant) {
          return variant.available;
        }) || variants[0] || null;

      const priceNumber = firstAvailableVariant
        ? parsePrice(firstAvailableVariant.price)
        : 0;

      let imageUrl = "";

      if (product.image && product.image.src) {
        imageUrl = product.image.src;
      } else if (
        Array.isArray(product.images) &&
        product.images.length &&
        product.images[0].src
      ) {
        imageUrl = product.images[0].src;
      }

      return {
        id: product.id || "",
        title: product.title || "",
        handle: product.handle || "",
        productType: product.product_type || "",
        vendor: product.vendor || "",
        url: rootUrl + "products/" + product.handle,
        image: imageUrl,
        variantId: firstAvailableVariant ? firstAvailableVariant.id : "",
        available: firstAvailableVariant ? Boolean(firstAvailableVariant.available) : false,
        priceNumber: priceNumber,
        priceText: formatMoney(priceNumber)
      };
    }

    function fetchProductsForCollection(handle) {
      if (productsCache[handle]) {
        return Promise.resolve(productsCache[handle]);
      }

      return fetch(getCollectionEndpoint(handle), {
        method: "GET",
        headers: {
          Accept: "application/json"
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Products request failed");
          }

          return response.json();
        })
        .then(function (data) {
          const products = Array.isArray(data.products) ? data.products : [];

          const normalizedProducts = products
            .map(normalizeProduct)
            .sort(function (a, b) {
              return b.priceNumber - a.priceNumber;
            });

          productsCache[handle] = normalizedProducts;

          return normalizedProducts;
        });
    }

    function buildCardHtml(product) {
      const imageHtml = product.image
        ? '<img class="modo-card-image" src="' +
          escapeAttribute(product.image) +
          '" alt="' +
          escapeAttribute(product.title) +
          '" loading="lazy" decoding="async">'
        : '<div class="modo-card-placeholder"></div>';

      const label = product.productType || product.vendor || "Product";

      return (
        '<article class="modo-swipe-card" data-modo-card data-product-id="' +
        escapeAttribute(product.id) +
        '" data-variant-id="' +
        escapeAttribute(product.variantId) +
        '" data-available="' +
        String(product.available) +
        '" data-title="' +
        escapeAttribute(product.title) +
        '" data-url="' +
        escapeAttribute(product.url) +
        '" data-price="' +
        escapeAttribute(product.priceText) +
        '" data-image="' +
        escapeAttribute(product.image) +
        '">' +
        '<a href="' +
        escapeAttribute(product.url) +
        '" class="modo-card-image-link" aria-label="' +
        escapeAttribute(product.title) +
        '">' +
        imageHtml +
        "</a>" +
        '<div class="modo-card-content">' +
        '<span class="modo-card-type">' +
        escapeHtml(label) +
        "</span>" +
        '<h2 class="modo-card-title">' +
        '<a href="' +
        escapeAttribute(product.url) +
        '">' +
        escapeHtml(product.title) +
        "</a>" +
        "</h2>" +
        '<div class="modo-card-price">' +
        escapeHtml(product.priceText) +
        "</div>" +
        "</div>" +
        "</article>"
      );
    }

    function loadCollection(handle) {
      activeIndex = 0;
      activeCards = [];

      showLoading();

      return fetchProductsForCollection(handle)
        .then(function (products) {
          hideLoading();

          if (!deck) return;

          if (!products.length) {
            deck.innerHTML = "";
            showEmpty();
            return;
          }

          hideEmpty();

          deck.innerHTML = products.map(buildCardHtml).join("");
          activeCards = Array.from(deck.querySelectorAll("[data-modo-card]"));

          renderCard();
        })
        .catch(function () {
          hideLoading();

          if (deck) {
            deck.innerHTML = "";
          }

          showEmpty();
          showToast("Products could not load");
        });
    }

    function resetCardStyles() {
      activeCards.forEach(function (card) {
        card.classList.remove(
          "active",
          "next-card",
          "third-card",
          "dragging",
          "swiping",
          "show-like",
          "show-nope"
        );

        card.style.transform = "";
        card.style.opacity = "";
      });
    }

    function renderCard() {
      resetCardStyles();

      if (!activeCards.length || activeIndex >= activeCards.length) {
        showEmpty();
        return;
      }

      hideEmpty();

      const activeCard = activeCards[activeIndex];
      const nextCard = activeCards[activeIndex + 1];
      const thirdCard = activeCards[activeIndex + 2];

      if (activeCard) {
        activeCard.classList.add("active");
        attachSwipeEvents(activeCard);
      }

      if (nextCard) {
        nextCard.classList.add("next-card");
      }

      if (thirdCard) {
        thirdCard.classList.add("third-card");
      }
    }

    function getActiveCard() {
      if (!activeCards.length || activeIndex >= activeCards.length) {
        return null;
      }

      return activeCards[activeIndex];
    }

    function goNext() {
      activeIndex += 1;
      renderCard();
    }

    function getCardProduct(card) {
      if (!card) return null;

      return {
        id: card.getAttribute("data-product-id") || "",
        variantId: card.getAttribute("data-variant-id") || "",
        title: card.getAttribute("data-title") || "",
        url: card.getAttribute("data-url") || "",
        price: card.getAttribute("data-price") || "",
        image: card.getAttribute("data-image") || "",
        addedAt: new Date().toISOString()
      };
    }

    function addToWishlist(card) {
      const product = getCardProduct(card);

      if (!product || !product.id) {
        showToast("Product not found");
        return false;
      }

      const wishlist = getWishlist();

      const alreadyExists = wishlist.some(function (item) {
        return String(item.id) === String(product.id);
      });

      if (alreadyExists) {
        showToast("Already in wishlist");
        return true;
      }

      wishlist.push(product);

      const saved = saveWishlist(wishlist);

      if (saved) {
        showToast("Added to wishlist");
        return true;
      }

      showToast("Wishlist could not be saved");
      return false;
    }

    function addToCart(card) {
      if (!card) return;

      const variantId = card.getAttribute("data-variant-id");
      const isAvailable = card.getAttribute("data-available") === "true";

      if (!variantId) {
        showToast("Product variant not found");
        return;
      }

      if (!isAvailable) {
        showToast("Product is sold out");
        return;
      }

      showToast("Adding to cart...");

      fetch(rootUrl + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Cart error");
          }

          return response.json();
        })
        .then(function () {
          showToast("Added to cart");

          animateCardOut(card, "up", function () {
            goNext();
          });
        })
        .catch(function () {
          showToast("Could not add to cart");
        });
    }

    function animateCardOut(card, direction, callback) {
      if (!card) return;

      card.classList.add("swiping");

      if (direction === "left") {
        card.style.transform = "translateX(-140%) rotate(-22deg)";
      }

      if (direction === "right") {
        card.style.transform = "translateX(140%) rotate(22deg)";
      }

      if (direction === "up") {
        card.style.transform = "translateY(-140%) scale(0.92)";
      }

      card.style.opacity = "0";

      setTimeout(function () {
        if (typeof callback === "function") {
          callback();
        }
      }, 320);
    }

    function skipCard(card) {
      animateCardOut(card, "left", function () {
        goNext();
      });
    }

    function wishlistCard(card) {
      if (!card) return;

      addToWishlist(card);

      animateCardOut(card, "right", function () {
        goNext();
      });
    }

    function attachSwipeEvents(card) {
      if (!card || card.dataset.swipeReady === "true") return;

      card.dataset.swipeReady = "true";

      function getPoint(event) {
        if (event.touches && event.touches.length) {
          return event.touches[0];
        }

        if (event.changedTouches && event.changedTouches.length) {
          return event.changedTouches[0];
        }

        return event;
      }

      function onStart(event) {
        if (!card.classList.contains("active")) return;

        const point = getPoint(event);

        startX = point.clientX;
        startY = point.clientY;
        currentX = 0;
        currentY = 0;
        isDraggingCard = true;

        card.classList.add("dragging");
      }

      function onMove(event) {
        if (!isDraggingCard || !card.classList.contains("active")) return;

        const point = getPoint(event);

        currentX = point.clientX - startX;
        currentY = point.clientY - startY;

        const rotate = currentX / 14;
        const opacity = Math.max(1 - Math.abs(currentX) / 500, 0.55);

        card.style.transform =
          "translate(" +
          currentX +
          "px, " +
          currentY +
          "px) rotate(" +
          rotate +
          "deg)";

        card.style.opacity = opacity;

        card.classList.toggle("show-like", currentX > 55);
        card.classList.toggle("show-nope", currentX < -55);
      }

      function onEnd() {
        if (!isDraggingCard || !card.classList.contains("active")) return;

        isDraggingCard = false;

        card.classList.remove("dragging", "show-like", "show-nope");

        if (currentX > 120) {
          wishlistCard(card);
          return;
        }

        if (currentX < -120) {
          skipCard(card);
          return;
        }

        card.classList.add("swiping");
        card.style.transform = "";
        card.style.opacity = "";

        setTimeout(function () {
          card.classList.remove("swiping");
        }, 250);
      }

      card.addEventListener("mousedown", onStart);
      window.addEventListener("mousemove", onMove);
      window.addEventListener("mouseup", onEnd);

      card.addEventListener("touchstart", onStart, { passive: true });
      window.addEventListener("touchmove", onMove, { passive: true });
      window.addEventListener("touchend", onEnd);
    }

    function initCategoryDragScroll() {
      if (!categoryScroll) return;

      let isDown = false;
      let startPageX = 0;
      let scrollStart = 0;
      let moved = false;

      categoryScroll.addEventListener("mousedown", function (event) {
        isDown = true;
        moved = false;
        startPageX = event.pageX;
        scrollStart = categoryScroll.scrollLeft;
        categoryScroll.classList.add("is-dragging");
      });

      categoryScroll.addEventListener("mouseleave", function () {
        isDown = false;
        categoryScroll.classList.remove("is-dragging");
      });

      categoryScroll.addEventListener("mouseup", function () {
        isDown = false;
        categoryScroll.classList.remove("is-dragging");

        setTimeout(function () {
          moved = false;
        }, 0);
      });

      categoryScroll.addEventListener("mousemove", function (event) {
        if (!isDown) return;

        event.preventDefault();

        const walk = (event.pageX - startPageX) * 1.4;

        if (Math.abs(walk) > 6) {
          moved = true;
        }

        categoryScroll.scrollLeft = scrollStart - walk;
      });

      categoryScroll.addEventListener(
        "click",
        function (event) {
          if (moved) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );
    }

    categoryButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        categoryButtons.forEach(function (btn) {
          btn.classList.remove("active");
        });

        button.classList.add("active");

        const selectedHandle = button.getAttribute("data-filter") || "all";

        loadCollection(selectedHandle);
      });
    });

    actionButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        const action = button.getAttribute("data-modo-action");
        const activeCard = getActiveCard();

        if (action === "home") {
          window.location.href = rootUrl;
          return;
        }

        if (action === "wishlist") {
          wishlistCard(activeCard);
          return;
        }

        if (action === "cart") {
          addToCart(activeCard);
          return;
        }
      });
    });

    window.modoSwipeGetWishlist = function () {
      return getWishlist();
    };

    initCategoryDragScroll();
    loadCollection("all");
  });
}